var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileBackgroundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBackgroundIcon);
export default __webpack_public_path__ + "static/media/profileBackgroundIcon.5a6efa6bcc5c357a53b4987bd003279c.svg";
export { ForwardRef as ReactComponent };